var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.1264C0.0733819 12.8432 0.137363 12.5966 0.203432 12.3499C0.4194 11.5616 0.640982 10.7748 0.84585 9.98453C0.875621 9.86636 0.862955 9.71007 0.80694 9.60417C-1.19579 5.78662 0.87092 1.16552 5.0738 0.178911C8.8907 -0.715513 12.322 1.8603 12.9484 5.30572C13.5999 8.89895 11.2495 12.3132 7.68447 12.9369C6.26736 13.1817 4.91254 12.9735 3.61882 12.3446C3.50366 12.2874 3.3411 12.2718 3.21836 12.3013C1.49441 12.7336 0.347715 13.0583 0 13.1264ZM1.51621 11.6309C2.16477 11.4624 2.76214 11.313 3.35389 11.1461C3.52155 11.1011 3.65042 11.1255 3.79849 11.2107C4.9192 11.8567 6.12021 12.098 7.40361 11.8912C10.3586 11.4173 12.3827 8.65217 11.9308 5.7088C11.4614 2.65705 8.60057 0.60967 5.57715 1.16395C1.91955 1.83575 -0.0220666 5.91354 1.79668 9.14234C1.99815 9.50011 2.05365 9.79507 1.91811 10.1757C1.7566 10.6337 1.65671 11.1116 1.51621 11.6309Z",
    fill: "url(#paint0_linear_1_357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24578 9.63356C6.97479 9.58826 4.94999 8.58494 3.56331 6.176C3.07092 5.31996 3.14195 4.3438 3.8635 3.67331C4.10728 3.44585 4.41308 3.50122 4.69969 3.54992C4.76993 3.5605 4.84332 3.66809 4.8787 3.74787C5.06346 4.16831 5.24535 4.58863 5.40608 5.01939C5.49122 5.24658 5.33466 5.46046 5.00588 5.83938C4.9009 5.95873 4.87922 6.0701 4.96122 6.20916C5.49461 7.11207 6.24005 7.7652 7.22052 8.14882C7.36454 8.20432 7.47214 8.16958 7.56354 8.0569C8.08309 7.42284 8.1361 7.23716 8.40952 7.36734C9.72465 7.99592 9.82728 8.02204 9.83341 8.17128C9.87807 9.27945 8.86182 9.679 8.24591 9.6337L8.24578 9.63356Z",
    fill: "url(#paint1_linear_1_357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_357",
    x1: -0.0299011,
    y1: 13.0965,
    x2: 11.1606,
    y2: 1.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#15B633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#19E53C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_357",
    x1: 5.0303,
    y1: 8.06147,
    x2: 7.40711,
    y2: 5.68465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16C736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#18DD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#19E53C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon_whatsapp.7d403057edb4de014cce86cbc20f603c.svg";
export { ForwardRef as ReactComponent };